import React from 'react';

import Layout from '../components/layout_customer_service';
import HeroPageIntro from '../sections/HeroPageIntro';
import LayoutPageWrapper from '../components/LayoutPageWrapper';
import Heading from '../components/Heading';

const IndexPage = () => (
  <Layout>
    <HeroPageIntro title="Customer Service" />
    <LayoutPageWrapper horizontalPadding="Small">



    <Heading type="h2" size="Small">We are here to help you</Heading>

    <p>We provide free 24/7 Customer Support to all our users.</p>

    <p>You can write to us by using Live Chat, Email or the <a href="https://endtest.io/contact" target="_blank" title="Contact Us">Contact Us</a> section.</p>

    <Heading type="h2" size="Small">World-Class Support</Heading>

    <p>Our Support Team is trained to deal with Selenium, Appium, JavaScript, DevOps and everything related to testing.</p>

    <p>If you get stuck at any point, we are here to help.</p>


    </LayoutPageWrapper>
  </Layout>
);

export default IndexPage;
